import {CommonModule} from '@angular/common';
import {Component, computed, input, output, ChangeDetectionStrategy} from '@angular/core';
import {SeFeButtonModule} from 'se-fe-button';
import {SeFeEmptyStateModule} from 'se-fe-empty-state';
import {SeFeSpinnerModule} from 'se-fe-spinner';
import {SeFeTableDataSource, SeFeTableModule} from 'se-fe-table';
import {ProductNameCellComponent} from '../../../../../common/components/product-table-cells/product-name-cell/product-name-cell.component';
import {ProductPriceCellComponent} from '../../../../../common/components/product-table-cells/product-price-cell/product-price-cell.component';
import {ProductStatusCellComponent} from '../../../../../common/components/product-table-cells/product-status-cell/product-status-cell.component';
import {getProductId, Product} from '../../../../../models/clare';

@Component({
  selector: 'bundle-products-table',
  imports: [
    CommonModule,
    ProductNameCellComponent,
    ProductPriceCellComponent,
    ProductStatusCellComponent,
    SeFeButtonModule,
    SeFeEmptyStateModule,
    SeFeSpinnerModule,
    SeFeTableModule,
  ],
  templateUrl: './bundle-products-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../../../../common/components/product-table/product-table.component.scss',
})
export class BundleProductsTableComponent {
  products = input<Product[] | undefined>();
  loading = input(false);
  showBundledPrice = input(true);

  removeFromBundle = output<Product>();

  displayedColumns = computed(() => {
    const columns = ['Name', 'Price'];
    if (this.showBundledPrice()) {
      columns.push('Bundled Price');
    }
    columns.push('Active', 'Delete');

    return columns;
  });

  datasource = computed(() => {
    const products = this.products() || [];
    return new SeFeTableDataSource(products);
  });

  getProductLink(product: Product): string {
    return '../../products/' + (getProductId(product) || '');
  }
}
